import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'global',
  })
  let booking_id = useDataValue({
    context: 'patient',
    path: 'booking.id',
    viewPath: props.viewPath,
  })
  let patient_id = useDataValue({
    context: 'patient',
    path: '_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (!booking_id) return

    submit({
      type: 'patientOverlay/open',
      patient_id,
    })
  }
}
